import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const rotateImage = keyframes`
100% {
    transform: rotate(360deg);
}`;

export const Container = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 380px;
  height: 380px;
`;

export const CircleLoading = styled.div`
  background-image: url(/img/loading_3.png);
  background-repeat: no-repeat;
  position: absolute;
  width: 380px;
  height: 380px;
  -webkit-animation: ${rotateImage} 1s linear infinite;
  animation: ${rotateImage} 1s linear infinite;
  transform-origin: 50% 50%;
`;

export const Content = styled.div`
  text-align: center;
  color: #ffffff;
  display: flex;
  justify-content: center;
  flex-direction: column;
  height: 100%;
`;

export const Title = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

export const Count = styled.div`
  font-size: 80px;
  line-height: 100px;
`;
